import { render } from "./GrandSearch.vue?vue&type=template&id=1b998688"
import script from "./GrandSearch.vue?vue&type=script&lang=js"
export * from "./GrandSearch.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__